import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import { vouchersItems } from '@/mock-data/vouchers';
import VoucherListItem from '@/components/voucher-list-item';
import useUserWalletsVouchersStore from '@/store/user-wallets-store';

const MoreUnusableVouchers = () => {
  const {
    unUsableVoucherAcceptorMerchants,
    unUsableVoucherPermissionItems,
    unUsableVoucherMinimumInvoiceAmounts,
  } = useUserWalletsVouchersStore();
  return (
    <Container className='flex flex-col items-start p-4 pt-6'>
      <Text semiBold className='text-xl text-grayLight-1000 dark:text-grayLight-0'>
        {localization.unUsableVouchers}
      </Text>
      <Text className='text-md mb-6 mt-2 text-grayLight-600 dark:text-grayDark-300'>
        {localization.unUsableVouchersInStore}
      </Text>
      <Container className='w-full lg:max-h-[380px] overflow-y-auto'>
        {unUsableVoucherAcceptorMerchants?.length > 0 &&
          unUsableVoucherAcceptorMerchants?.map((item, index) => (
            <VoucherListItem
              data={item}
              key={index}
              unUsable
              disable={localization.notUseAbleInThisStore}
            />
          ))}
        {unUsableVoucherPermissionItems?.length > 0 &&
          unUsableVoucherPermissionItems?.map((item, index) => (
            <VoucherListItem
              data={item}
              key={index}
              unUsable
              disable={localization.voucherPermissionItem}
            />
          ))}
        {unUsableVoucherMinimumInvoiceAmounts?.length > 0 &&
          unUsableVoucherMinimumInvoiceAmounts?.map((item, index) => (
            <VoucherListItem
              data={item}
              key={index}
              unUsable
              disable={localization.voucherMinimumInvoiceAmount}
            />
          ))}
      </Container>
    </Container>
  );
};

export default MoreUnusableVouchers;
